import { ModalService } from './utils/modal.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from 'src/app/core/auth.service';
import { HttpErrorResponse } from "@angular/common/http";
import { tap } from "rxjs/internal/operators";
import * as Config from '../../config/app.constant';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  errorMessage: string;
  alertText: string = '';

  constructor(
    public auth: AuthService,
    public translate: TranslateService,
    public modalService: ModalService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;
    headers = headers.set("Access-Control-Allow-Origin", "*");
    headers = headers.set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
    const smartclaimToken = this.auth.getSmartclaimToken();
    const adminToken = this.auth.getAdminToken();
    if (headers.get('configToken') === Config.SMARTCLAIM_TOKEN_KEY) {
      headers = headers.set('Authorization', 'Bearer ' + `${smartclaimToken}`);
      headers = headers.delete('configToken');
    } else if (headers.get('configToken') === Config.ADMIN_TOKEN_KEY) {
      headers = headers.set('Authorization', `${adminToken}`);
      headers = headers.delete('configToken');
    } else {
      headers = headers.set('Content-type', Config.CONTENT_TYPE);
    }
    const newReq = request.clone({ headers });
    return next.handle(newReq).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.log("Login Error ..");

          switch (err.status) {

            case 0:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'ทำรายการไม่สำเร็จ';
              } else {
                this.alertText = 'Failed to complete the transaction';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 204:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'ไม่มีข้อมูล';
              } else {
                this.alertText = 'No Content';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 205:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'แบบประกันไม่ถูกต้อง';
              } else {
                this.alertText = 'Invalid Policy';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 206:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'วันเดือนปีไม่ถูกต้อง';
              } else {
                this.alertText = 'Invalid Date';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 207:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'เกิดข้อผิดพลาดในการเช็คสิทธิ์ของโรงพยาบาล';
              } else {
                this.alertText = 'A problem has been occurred while eligibility verification';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 208:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'โรงพยาบาลของท่าน ไม่มีสิทธิ์เข้าใช้ระบบ !';
              } else {
                this.alertText = 'Unauthorized Hospital';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 400:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'การค้นหาไม่ถูกต้อง';
              } else {
                this.alertText = 'Invalid Search';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 401:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'ระบบไม่สามารถทำรายการได้';
              } else {
                this.alertText = 'Unable to complete the transaction';
              }
              this.modalService.error(this.alertText, '');
              this.auth.logout();
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 403:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'ระบบไม่อนุญาตให้ทำรายการได้';
              } else {
                this.alertText = 'Unauthorized to complete the transaction';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 404:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'ไม่พบข้อมูลที่ต้องการในระบบ';
              } else {
                this.alertText = 'Data not found';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 408:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Request Timeout Errors';
              } else {
                this.alertText = 'Request Timeout Errors';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 500:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Internal Server Error';
              } else {
                this.alertText = 'Internal Server Error';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 503:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Service Unavailable';
              } else {
                this.alertText = 'Service Unavailable';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 504:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Gateway Timeout';
              } else {
                this.alertText = 'Gateway Timeout';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 598:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Network read timeout error';
              } else {
                this.alertText = 'Network read timeout error';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            case 599:
              if (this.translate.currentLang == 'th') {
                this.alertText = 'Network connect timeout error';
              } else {
                this.alertText = 'Network connect timeout error';
              }
              this.modalService.error(this.alertText, '');
              this.errorMessage = err.error.message || err.statusText;
              break;

            default:
              break;
          }

          return throwError(this.errorMessage);
        }
      }));
  }
}
